





















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class IconButton extends Vue {
  @Prop() type!: "icon" | "button";
  @Prop() size!: "small" | "medium" | "large" | "enormous";
  @Prop() background!: string;
  @Prop() levitate!: boolean;
  @Prop() onClick!: () => void;

  handleClick() {
    this.onClick && this.onClick();
  }
}
